// extracted by mini-css-extract-plugin
export default {"zoomModal":"g1-z"};